(() => {
  const SEEN = new WeakSet();

  function initWideIWT(root) {
    if (!root || SEEN.has(root)) return;
    SEEN.add(root);

    const video = root.querySelector('video.iwt-media');
    const button = root.querySelector('[data-iwt-vid-toggle]');
    const live = root.querySelector('[data-live]');

    if (!video || !button) return;

    video.setAttribute('playsinline', 'true');

    let userPaused = true;
    let isInView = false;

    const announce = (msg) => {
      if (!live) return;
      live.textContent = msg;
    };

    const setButtonState = (playing) => {
      button.setAttribute('aria-pressed', String(playing));
      button.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
      const playEl = button.querySelector('.iwt-vid-play');
      const pauseEl = button.querySelector('.iwt-vid-pause');
      if (playEl && pauseEl) {
        if (playing) {
          playEl.hidden = true;
          pauseEl.hidden = false;
        } else {
          playEl.hidden = false;
          pauseEl.hidden = true;
        }
      }
    };

    const pauseVideo = () => {
      if (!video.paused) {
        video.pause();
        setButtonState(false);
        announce('Video paused');
      }
    };

    const playVideo = async () => {
      try {
        await video.play();
        setButtonState(true);
        announce('Video playing');
      } catch (e) {
        setButtonState(false);
      }
    };

    pauseVideo();

    const toggle = (e) => {
      if (e && e.type === 'keydown') {
        const isActivationKey = e.key === 'Enter' || e.key === ' ';
        if (!isActivationKey) return;
        e.preventDefault();
      }
      if (video.paused) {
        userPaused = false;
        playVideo();
      } else {
        userPaused = true;
        pauseVideo();
      }
    };

    button.addEventListener('click', toggle);
    button.addEventListener('keydown', toggle);

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          isInView = entry.isIntersecting && entry.intersectionRatio >= 0.35;
          if (!isInView) {
            pauseVideo();
          }
        });
      },
      { threshold: [0, 0.35, 1] }
    );
    io.observe(root);

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        pauseVideo();
      }
    });

    let resizeTimer = null;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      pauseVideo();
      resizeTimer = setTimeout(() => {
      }, 200);
    });

    window.addEventListener('pagehide', pauseVideo);
    window.addEventListener('beforeunload', pauseVideo);

    document.addEventListener('shopify:section:unload', (evt) => {
      if (evt.detail && evt.detail.sectionId === root.dataset.sectionId) {
        try {
          io.disconnect();
        } catch (_) {}
      }
    });
  }

  const boot = () => {
    document.querySelectorAll('[data-vid-root]').forEach(initWideIWT);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (evt) => {
    const sc = evt.target && evt.target.querySelector('[data-vid-root]');
    if (sc) initWideIWT(sc);
  });
})();
